import { handleError } from ".";
import { api } from ".";

export default {
  async login({ email, password }) {
    try {
      const response = await api.post("/login", {
        email,
        password,
      });

      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  async registration({ email }) {
    try {
      const response = await api.post("/registration", {
        email,
      });

      return response.data;
    } catch (error) {
      throw handleError(error);
    }
  },

  async checkIn() {
    try {
      const response = await api.get("/login");

      if (response.data?.buyer_info) {
        return response.data.buyer_info;
      } else {
        return null;
      }
    } catch (error) {
      throw handleError(error);
    }
  },

  // async confirm({ email, name, phone, password }) {
  //   try {
  //     const response = await api.post("/confirmation", {
  //       email,
  //       name,
  //       phone,
  //       password,
  //     });

  //     if (response.data?.buyer_info) {
  //       return response.data.buyer_info;
  //     } else {
  //       return null;
  //     }
  //   } catch (error) {
  //     throw handleError(error);
  //   }
  // },

  async forgetPassword({email}) {
    try {
      const response = await api.post("/forgot_password", {
        email
      });

      if (response.data) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      throw handleError(error);
    }
  },
  async logout() {
    try {
      const response = await api.get("/logout");

      if (response.data) {
        return response.data;
      } else {
        return null;
      }
    } catch (error) {
      throw handleError(error);
    }
  },
  async profile({
    type,
    firstName,
    lastName,
    phone,
    new_password,
    repeat_password,
  }) {
    try {
      let response;

      if (type === "personal_data") {
        response = await api.post("/profile", {
          type,
          firstname: firstName,
          lastName: lastName,
          phone,
        });
      } else {
        response = await api.post("/profile", {
          type,
          new_password,
          repeat_password,
        });
      }      
      if (response) {
        //stutus ok
        return response;
      } else {
        return null;
      }
    } catch (error) {
      throw handleError(error);
    }
  },
};
